<template>
    <map-section
        class="map-section-module"
        :markers="attributes.markers"
    />
</template>

<script>
    import MapSection from '../../../organisms/MapSection/MapSection';

    export default {
        name: 'map-section-module',

        components: { MapSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>
